import React from 'react';
import {Navigate} from 'react-router-dom';
import {isExternalUser} from '../../permissions/usePermissions';
import {MRAppRoutes} from './routes';

/**
 * Root route redirect component
 * - Internal users → /model/filter (can navigate to model list from there)
 * - External users → /model/list (direct access)
 */
const RootRedirect: React.FC = () => {
  const externalUser = isExternalUser();
  const isExternalUserFlag = externalUser !== null ? externalUser : false;

  // External users go directly to model list
  if (isExternalUserFlag) {
    return <Navigate to={MRAppRoutes.MODEL_LIST} replace />;
  }

  // Internal users start at filter page
  return <Navigate to={MRAppRoutes.FILTER_PAGE} replace />;
};

export default RootRedirect;
